import React, { Component } from 'react';
import banner from '../../assets/img/vector/desarrollo-software.svg';
import img from '../../assets/img/vector/desarrollo-img.svg';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';
import ImageText from '../../subcomponents/ImageText';
import TextImage from '../../subcomponents/TextImage';
import IconBlock28 from '../../subcomponents/IconBlock28';
import img1 from '../../assets/img/flat/desarrollo1.svg';
import img2 from '../../assets/img/flat/desarrollo2.svg';
import img3 from '../../assets/img/flat/desarrollo3.svg';
import react from '../../assets/img/brand/react.png';
import symfony from '../../assets/img/brand/symfony.svg';
import projectIcon from '../../assets/img/vector/project.svg';
import userIcon from '../../assets/img/vector/userIcon.svg';
import fileIcon from '../../assets/img/vector/fileIcon.svg';
import yearIcon from '../../assets/img/vector/yearIcon.svg';
import developer from '../../assets/img/vector/developer.svg';
import proyectos from '../../assets/data/proyectos.json';
import ProyectoPreview from '../../subcomponents/ProyectoPreview';
class DesarrolloSoftware extends Component {
  componentDidMount() {
    document.title = 'Desarrollo de Software - Insacom';
    /* eslint-disable */
    $.HSCore.components.HSCounter.init('[class*="js-counter"]');
  }

  render() {
    let iconBlocks = [
      {
        id: 1,
        title: 'Metodología',
        description: 'Utilizamos metodologías ágiles para nuestros desarrollos',
        img: img1
      },
      {
        id: 2,
        title: 'Web',
        description: 'Nos especializamos en desarrollo de sistemas web',
        img: img2
      },
      {
        id: 3,
        title: 'Integración',
        description: 'Desarrollamos integraciones con todo tipo de sistemas',
        img: img3
      }
    ];

    this.proyectosHtml = proyectos
      .filter(proyecto => proyecto.categoria === 'desarrollo')
      .map((item, key) => (
        <ProyectoPreview
          key={key}
          name={item.name}
          slug={'/proyectos/' + item.slug}
          desc={item.desc}
          image={require('../../assets/img/proyectos' + item.img)}
        />
      ));

    const descripcion =
      'Creamos y desarrollamos soluciones informáticas a medida que permiten satisfacer las necesidades diarias de tu empresa.';

    return (
      <Section asuntoContacto={'Desarrollo de Software'}>
        <SectionContainer paddingBottom={'0px'} backgroundColor="#3043a0">
          <ImageText
            image={banner}
            color="white"
            title="Desarrollo de Software"
            description={descripcion}>
            <div className="d-flex ">
              <div className="">
                <img src={symfony} alt="Symfony" style={{ height: '80px' }}></img>
              </div>
              <div className="">
                <img src={react} alt="React" style={{ height: '70px' }}></img>
              </div>
            </div>
          </ImageText>
        </SectionContainer>
        <SectionContainer>
          <IconBlock28 content={iconBlocks}></IconBlock28>
        </SectionContainer>
        <SectionContainer grey paddingBottom={'0px'}>
          <TextImage
            image={developer}
            title="Software a Medida">
            <p>
              <span>
                Nos especializamos en Sistemas Web, Integraciones B2B y Aplicaciones Móviles.
              </span>
              <span> Realizamos proyectos tecnológicos personalizados</span> y adaptados a cada
              empresa o idea de negocio. <span>Estudiamos los proyectos y aportamos</span> la mejor
              solución en función de los objetivos y las necesidades que se pretenden cubrir.
            </p>
            <p>Te hacemos partícipe de todo el ciclo de desarrollo para asegurar que el producto final sea lo que realmente necesitas.</p>
            <ul className="list-unstyled mb-0">
              <li className="mb-3">
                <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                Identificamos tus necesidades y trabajamos en base a ellas.
              </li>
              <li className="mb-3">
                <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                Te entregamos prototipos funcionales en etapas tempranas del desarrollo del sistema.
              </li>
              <li className="mb-3">
                <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                Avanzamos en base a tu retroalimentación, la cual es clave para ir en la dirección
                correcta.
              </li>
            </ul>
          </TextImage>
        </SectionContainer>
        <SectionContainer>
          <div className="row text-center">
            <div className="col-md-3">
              <img height="150px" src={projectIcon}></img>
              <div className="g-line-height-1 mt-4 g-font-size-40">
                +<span className="js-counter">50</span>
              </div>
              <div className="g-font-size-20">Proyectos SaaS Activos</div>
            </div>
            <div className="col-md-3">
              <img height="150px" src={userIcon}></img>
              <div className="g-line-height-1 mt-4 g-font-size-40">
                +<span className="js-counter">3</span>K
              </div>
              <div className="g-font-size-20">Usuarios Activos</div>
            </div>
            <div className="col-md-3">
              <img height="150px" src={fileIcon}></img>
              <div className="g-line-height-1 mt-4 g-font-size-40">
                +<span className="js-counter">50</span>M
              </div>
              <div className="g-font-size-20">Archivos Digitalizados</div>
            </div>
            <div className="col-md-3">
              <img height="150px" src={yearIcon}></img>
              <div className="g-line-height-1 mt-4 g-font-size-40">
                +<span className="js-counter">10</span>
              </div>
              <div className="g-font-size-20">Años de Experiencia</div>
            </div>
          </div>
        </SectionContainer>
        <SectionContainer>
          <header className="text-center g-width-60x--md mx-auto g-mb-50">
            <h2 className="h1 g-color-gray-dark-v1 g-font-weight-300">
              Algunos de Nuestros Sistemas
            </h2>
          </header>
          <div className="row">{this.proyectosHtml}</div>
        </SectionContainer>
      </Section>
    );
  }
}

export default DesarrolloSoftware;



// WEBPACK FOOTER //
// ./src/sections/software/DesarrolloSoftware.js